import css from '@emotion/css';
import { MediaQueries } from '../../../../styles/Grid';

const converted = {
  // '.InfiniteCarousel': {
  position: 'relative',
  width: '100%',
  maxWidth: '1440px',
  margin: '0 auto',
  // },
  '.InfiniteCarouselSlide': {
    width: '330px !important',
    height: '530px !important',

    '.swiper-slide': { width: '304px', [MediaQueries.md]: { width: '320px' } },
  },
  '.InfiniteCarouselFrame': {
    width: 'calc(100% + 78px)',
    overflow: 'hidden',
    ul: { display: 'flex !important' },
  },
  '.InfiniteCarouselScrollTrack': {
    overflowX: 'scroll',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch',
    overflow: '-moz-scrollbars-none',
    WebkitBoxSizing: 'border-box',
  },
  '.InfiniteCarouselScrollTrack::-webkit-scrollbar': { display: 'none' },
  '.InfiniteCarouselSlide img': { width: '100%' },
  '.InfiniteCarouselPaging': {
    position: 'absolute',
    left: '50%',
    bottom: '-60px',
    padding: '0',
    transform: 'translateX(-20%)',
    letterSpacing: '2px',
    color: '#888',
  },
  '.InfiniteCarouselDots': {
    position: 'absolute',
    left: '50%',
    bottom: '0',
    padding: '0',
    transform: 'translateX(-50%)',
  },
  '.InfiniteCarouselDot': {
    display: 'inline-block',
    listStyle: 'none',
    margin: '0 5px',
    border: '0',
    background: 'none',
    cursor: 'pointer',
  },
  '.InfiniteCarouselDotIcon': {
    display: 'block',
    backgroundColor: '#e5e5e5',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
  },
  '.InfiniteCarouselDotActiveIcon': { backgroundColor: '#48799a' },
  '.InfiniteCarouselArrow:focus': { outline: 'none' },
  '.InfiniteCarouselArrow': {
    display: 'block',
    background: 'none',
    border: 'none',
    position: 'absolute',
    top: '50%',
    zIndex: 2,
    outline: 'none',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  '.InfiniteCarouselArrowPrev': { right: 'auto', left: '20px' },
  '.InfiniteCarouselArrowNext': { left: 'auto', right: '20px' },
  '.InfiniteCarouselArrowIcon': {
    right: 'auto',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '0',
    outline: '0px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
  },
  '.InfiniteCarouselArrowNextIcon': { transform: 'rotate(-45deg)' },
  '.InfiniteCarouselArrowPrevIcon': { transform: 'rotate(135deg)' },
};

export const infiniteAllStyle = css(converted);
